import React from "react";
import ButterflyLottie from "../plantationOneComponents/ButterflyLottie";

import PlantationOneBannerOne from "../plantationOneComponents/PlantationOneBannerOne";
// import PlantationOneAboutUs from '../plantationOneComponents/PlantationOneAboutUs'
// import PlantationOneHowWeWork from '../plantationOneComponents/PlantationOneHowWeWork'
import PlantationOneCounter from "../plantationOneComponents/PlantationOneCounter";
import PlantationOneOffer from "../plantationOneComponents/PlantationOneOffer";
import PlantationOneAboutOne from "../plantationOneComponents/PlantationOneAboutOne";
import PlantationOneAdoptATree from "../plantationOneComponents/PlantationOneAdoptATree";
import PlantationOneCategory from "./../plantationOneComponents/PlantationOneCategory";
import PlantationOneBenifit from "../plantationOneComponents/PlantationOneBenifit";
import PlantationOneFooter from "../plantationOneComponents/PlantationOneFooter";
import PlantationOneCertificate from "../plantationOneComponents/PlantationOneCertificate";
import PlantationOneArrival from "../plantationOneComponents/PlantationOneArrival";
import PlantationOneTestimonial from "../plantationOneComponents/PlantationOneTestimonial";

// ... other imports

// Import just the separator component with type variants
import PlantationSeparator from "../plantationOneComponents/PlantationOneSeparator";

const PlantationOneHome = () => {
  return (
    <div>

      <PlantationOneBannerOne />
       <ButterflyLottie />


      <PlantationOneCounter />
      {/* <PlantationOneCertificate/> */}
            <PlantationSeparator type={1} />
                  <PlantationOneArrival/>
                     
 

       <PlantationOneTestimonial/>
      <PlantationOneOffer/>

      <PlantationOneAdoptATree />

      <PlantationSeparator type={2} />

      <PlantationOneAboutOne />


      <PlantationSeparator type={3} />
      <PlantationOneCategory />
      <PlantationSeparator type={4} />
      
      <PlantationOneBenifit />
      

    </div>
  );
};

export default PlantationOneHome;
